import Grid from '@mui/material/Grid'
import {
    Chip, Typography,
} from '@mui/material'
import { ApiUserFilter } from '@tap/data-providers';

import { IComponentCss } from '@tap/mui-ui';

/*
*   Итем фильтра
*/

const css: IComponentCss = {
    item: {
        width: '100%',
        height: '55px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        padding: '13.5px 16px',
        cursor: 'pointer',
        ':hover': {
            background: '#F5F5F5',
        },
    },
    name: {
        flexWrap: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        paddingRight: '10px',
        lineHeight: 1.38,
        wordWrap: 'break-word',
        wordBreak: 'break-all',
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
    },
    itemActive: {
        background: '#EBEBEB',
        ':hover': {
            background: '#EBEBEB',
        },
    },
    chip: {
        fontWeight: 700,
    },
}
export const FilteredRowsCount = ({
    count,
}: {
    count: number,
}) => {

    return (
        <Chip label={count}
            size='small'
            sx={css.chip} />
    );
};

export type FilterMenuItem = ApiUserFilter & {
    count: number,
}

type UserFilterMenuItemProps = {
    filter: FilterMenuItem,
    currentFilter?: ApiUserFilter,
    handleChangeCurrentFilter: (selectedFilter: ApiUserFilter) => void,
}

export default function UserFilterMenuItem({
    filter,
    currentFilter,
    handleChangeCurrentFilter,
}: UserFilterMenuItemProps) {

    return (
        <Grid
            container
            sx={{
                ...css.item,
                ...(currentFilter?.id === filter.id && { ...css.itemActive }),
            }}
            justifyContent="space-between"
            alignItems="center"
            onClick={() => handleChangeCurrentFilter(filter)}
            wrap='nowrap'
        >

            <Typography sx={css.name}>
                {filter.name}
            </Typography>

            <Grid item>
                <FilteredRowsCount
                    count={filter.count}
                />
            </Grid>

        </Grid >
    );
}
